import React from "react";
import { Link } from "react-router-dom";

import "./Error404.css";

const Error404 = ({ message = "" }) => (
	<div className="Error404">
		{/* <h1>404</h1> */}
		{message && <p>{message}</p>}
		<p>
			<Link to="/">&larr; Back</Link>
		</p>
	</div>
);

export default Error404;



// WEBPACK FOOTER //
// ./src/components/Error404.js